/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Resources_Card_Next_PhotoInputs */

const en_admin_resources_card_next_photo = /** @type {(inputs: Admin_Resources_Card_Next_PhotoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Next photo`)
};

const de_admin_resources_card_next_photo = /** @type {(inputs: Admin_Resources_Card_Next_PhotoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nächstes Foto`)
};

const es_admin_resources_card_next_photo = /** @type {(inputs: Admin_Resources_Card_Next_PhotoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Siguiente foto`)
};

const fr_admin_resources_card_next_photo = /** @type {(inputs: Admin_Resources_Card_Next_PhotoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Photo suivante`)
};

/** @type {(inputs: Admin_Resources_Card_Next_PhotoInputs) => LocalizedString} */
const it_admin_resources_card_next_photo = en_admin_resources_card_next_photo;

/** @type {(inputs: Admin_Resources_Card_Next_PhotoInputs) => LocalizedString} */
const pt_br2_admin_resources_card_next_photo = en_admin_resources_card_next_photo;

/** @type {(inputs: Admin_Resources_Card_Next_PhotoInputs) => LocalizedString} */
const pl_admin_resources_card_next_photo = en_admin_resources_card_next_photo;

/** @type {(inputs: Admin_Resources_Card_Next_PhotoInputs) => LocalizedString} */
const hu_admin_resources_card_next_photo = en_admin_resources_card_next_photo;

/** @type {(inputs: Admin_Resources_Card_Next_PhotoInputs) => LocalizedString} */
const ro_admin_resources_card_next_photo = en_admin_resources_card_next_photo;

/**
* | output |
* | --- |
* | "Next photo" |
*
* @param {Admin_Resources_Card_Next_PhotoInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_resources_card_next_photo = /** @type {((inputs?: Admin_Resources_Card_Next_PhotoInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Resources_Card_Next_PhotoInputs, { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_resources_card_next_photo(inputs)
	if (locale === "de") return de_admin_resources_card_next_photo(inputs)
	if (locale === "es") return es_admin_resources_card_next_photo(inputs)
	if (locale === "fr") return fr_admin_resources_card_next_photo(inputs)
	if (locale === "it") return it_admin_resources_card_next_photo(inputs)
	if (locale === "pt-BR") return pt_br2_admin_resources_card_next_photo(inputs)
	if (locale === "pl") return pl_admin_resources_card_next_photo(inputs)
	if (locale === "hu") return hu_admin_resources_card_next_photo(inputs)
	return ro_admin_resources_card_next_photo(inputs)
});
export { admin_resources_card_next_photo as "admin.resources.card.next_photo" }